module.exports = __webpack_public_path__ + "static/media/itakeoff.68726eff.svg";